var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information",class:{
    'information--full-width': _vm.fullwidth,
  }},[(_vm.getInfo && _vm.getInfo.title)?_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.getInfo.title)}}):_vm._e(),(_vm.getInfo && _vm.getInfo.body)?_c('div',{ref:"content",staticClass:"templates-content",domProps:{"innerHTML":_vm._s(_vm.infoBody)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }